import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useCookie from "../../hooks/useCookie";
import { isWebView } from "../../utils/helpers";
import { COOKIE_CONSENT_KEY } from "../../utils/constants";
import ROUTES from "../../utils/routes";
import BaseButton from "../BaseButton";
import "./style.scss";

// Базовый cookie-нотис с фиксацией согласия (для модерации/регуляторов).
// Язык подтягивается из i18n, который уже привязан к домену (см. i18n.js
// detectDomainLang), поэтому отдельный маппинг доменов здесь не нужен.
export default function CookieNotice() {
  const { t, i18n } = useTranslation();
  const { getCookie, setCookie } = useCookie();
  const { pathname } = useLocation();
  // Не показываем внутри нативного приложения (RN webview) и если выбор уже сделан.
  const [visible, setVisible] = useState(
    () => !isWebView() && !getCookie(COOKIE_CONSENT_KEY)
  );

  // Скрываем на игровых экранах: фиксированная плашка снизу перекрывает
  // нижний ряд игровых контролов (иконки info/insight/shop, свайп-кнопки).
  // pathname приходит без basename, поэтому сравниваем с чистыми роутами.
  // startsWith("/in-game") покрывает и /in-game/edit.
  const isGameRoute = [ROUTES.IN_GAME_PAGE, ROUTES.END_GAME_PAGE].some((r) =>
    pathname.startsWith(r)
  );

  if (!visible || isGameRoute) return null;

  const decide = (value) => {
    setCookie(COOKIE_CONSENT_KEY, value, {
      expires: 180,
      sameSite: "strict",
      path: "/",
    });
    setVisible(false);
  };

  // Префикс пути = basename роутера. ВАЖНО: повторяет логику MainRouter
  // (createBrowserRouter basename): пусто на чистых wepurplay-доменах,
  // "/game" на всех остальных (in-touch.space, localhost, dev/staging).
  // Раньше тут было endsWith("in-touch.space") — это ломало ссылку на
  // localhost, где роуты реально под /game. Держать в синхроне с роутером.
  const WEPURPLAY_HOSTS = [
    "wepurplay.com",
    "www.wepurplay.com",
    "wepurplay.ru",
    "www.wepurplay.ru",
  ];
  const prefix =
    typeof window !== "undefined" &&
    WEPURPLAY_HOSTS.includes(window.location.hostname)
      ? ""
      : "/game";
  const privacyHref =
    i18n.language === "en" ? `${prefix}/privacy-payplus` : `${prefix}/privacy`;

  return (
    <div className="cookie-notice" role="dialog" aria-live="polite">
      <p className="cookie-notice__text">
        {t("cookie_notice.text")}{" "}
        <a
          className="cookie-notice__link"
          href={privacyHref}
          target="_blank"
          rel="noreferrer"
        >
          {t("cookie_notice.more")}
        </a>
      </p>
      <div className="cookie-notice__actions">
        <BaseButton onClick={() => decide("accepted")}>
          {t("cookie_notice.accept")}
        </BaseButton>
        <BaseButton unfilledWhite negative onClick={() => decide("rejected")}>
          {t("cookie_notice.reject")}
        </BaseButton>
      </div>
    </div>
  );
}
